<template>
	<div id="d-flex flex-center">
		<template v-if="!invitationInvalid">
			<span class="onboarding-title text-center d-block mb-10 mt-4">
				You accepted invitation to join
				<br />
				<span class="font-bold">{{ organization }}</span>
				organisation.
			</span>
			<v-btn color="primary" large depressed block rounded @click="goToLogin">
				Log In
			</v-btn>
		</template>

		<template v-else>
			<span class="onboarding-title text-center d-block mb-10 mt-4">
				Invalid or already used invitation.
			</span>
			<v-btn color="primary" large depressed block rounded @click="goToLogin">
				Log In
			</v-btn>
		</template>
	</div>
</template>

<script>
export default {
	data() {
		return {
			invitationInvalid: false,
		};
	},
	computed: {
		organization() {
			return this.$route.query.organization;
		},
	},
	created() {
		if (!this.$route.query.invitation_token) {
			this.$router.push({ name: "app" });
		} else {
			this.$store.dispatch("Invitations/acceptInvitationViaToken", this.$route.query.invitation_token).catch(err => {
				this.invitationInvalid = true;
			});
		}
	},
	methods: {
		goToLogin() {
			this.$router.push({ name: "login" });
		},
	},
};
</script>